import { render } from "./App.vue?vue&type=template&id=5610e1ba"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5610e1ba&lang=css"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__